import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Column",
  icon: "list-view",
  lazyLoad: false,
}

export default defineBlock("parts/megamenu-column", (props) => {
  const [columnLabel] = useInlineEditableValue<string>("label")
  return (
    <div className="py-5" data-mixpanel-menu-column={columnLabel.replace("&ampl", "&")}>
      <EditableText
        as="div"
        store="label"
        placeholder="Title"
        plainText
        className="type-label-caps mb-3 text-fg-secondary"
        appendOnEnter="core/navigation-link"
        disableLineBreaks
      />
      <div className="el-a:inline-block el-a:py-[0.3em] el-a:underline-offset-4 el-a:transition-colors el-a:duration-150 el-a:underline el-a:decoration-transparent hover:el-a:decoration-fg/50 focus:el-a:decoration-fg/50 hover:el-a:duration-0 focus:el-a:duration-0 el-a:rounded-sm el-a:px-2 el-a:-mx-2">
        <InnerBlocks
          allowedBlocks={["core/navigation-link"]}
          appender={{ type: "simple" }}
          adminClassName="stack-y-2"
          orientation="vertical"
          templateLock={false}
        />
      </div>
    </div>
  )
})

// @ts-ignore
if (env.admin && window.wp) {
  try {
    // @ts-ignore
    wp.hooks.addFilter("blocks.registerBlockType", "eddev/parts-megamenu-column", (settings, name) => {
      if (name === "core/navigation-link") {
        return {
          ...settings,
          parent: [...(settings.parent || []), "acf/parts-megamenu-column"],
        }
      }
      return settings
    })
  } catch (err) {
    console.log("Errrorrrrr")
  }
}
